/* =============================================================
 * import
 * ========================================================== */
import Bowser from "bowser";


/* =============================================================
 * mediaQuery
 * レスポンシブ判定
 * ========================================================== */
const windowWidth = window.innerWidth;

export function mediaQuery(width = windowWidth) {
  if (width <= 768) {
    return 'sp';
  } else {
    return 'pc';
  }
}


/* =============================================================
 * isMobile
 * タッチデバイス（SP、タブレット含む）の判別
 * ========================================================== */
export const isMobile = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isTouchDevice = 'ontouchstart' in window;
  if (browser.getPlatformType(true) === 'tablet' || browser.getPlatformType(true) === 'mobile' || isTouchDevice === true) {
    return true;
  } else {
    return false;
  }
};


/* =============================================================
 * isSafari
 * Safariブラウザの判別（一部バグ回避用）
 * ========================================================== */
export const isSafari = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  if (browser.getBrowserName() === "Safari") {
    return true;
  } else {
    return false;
  }
};


// =============================================================
// webpのサポートをチェックする関数
// =============================================================
export function supportsWebp() {
  const canvas = document.createElement("canvas");
  let webp;
  if (canvas.getContext && canvas.getContext("2d")) {
    // canvasがwebpをサポートしているかチェック
    webp = canvas.toDataURL("image/webp").indexOf("data:image/webp") == 0;
  } else {
    webp = false;
  }
  if (!webp) {
    document.body.classList.add("no-webp"); // webpをサポートしていない場合は、`no-webp`クラスをbodyタグに追加
  }
}


// =============================================================
// スクロールバーなどを除いた画面の高さを正確に取得（主にスマホデバイス用
// =============================================================
export function setViewport() {
  const vw = document.documentElement.clientWidth * 0.01; // スクロールバーを含まないviewportサイズ
  const vh = window.innerHeight * 0.01; // スクロールバーを含むviewportサイズ
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}


/* =============================================================
 * toggleClass
 * ========================================================== */

export function toggleClass(e, n) {
  e.classList.toggle(n);
}


// =============================================================
// PC→SPなどのデバイス（正確にはデザイン基準）変更が発生した際に再読み込み
// =============================================================
export function switchMediaReload (currentWindowWidth, currentDevice) {
  let nextDevice;
  const nextWindowWidth = window.innerWidth;
  if (currentWindowWidth !== nextWindowWidth) {
    nextDevice = mediaQuery(nextWindowWidth);
  }

  if (nextDevice !== undefined && nextDevice !== currentDevice) {
    // PC→SPなどのデバイス（正確にはデザイン基準）変更が発生した際に再読み込み
    location.reload(); // ページを再読み込み
  }
}


